var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Box, FormControl } from "@mui/material";
import { buildFieldValidation } from "../../validators/field-components";
import { useElementConditions, useFormLogic, } from "../../context/FormLogicContext";
import Header from "../common/Header";
import CommentFieldInput from "./CommentFieldInput";
import { getInitialValueForElement, resolveTextUpdateMode, } from "../../../../utils/forms-functions";
import { getElementValueKey } from "../../../../utils/helpers";
import { useClearInvisibleValue } from "../../hooks/useClearInvisibleValue";
var CommentField = function (_a) {
    var _b;
    var element = _a.element, errors = _a.errors;
    var _c = useFormLogic(), globalConstraints = _c.globalConstraints, globalTextUpdateMode = _c.textUpdateMode;
    var unregister = useFormContext().unregister;
    var valueKey = getElementValueKey(element);
    var error = errors[valueKey];
    var _d = useElementConditions(element), isVisible = _d.isVisible, isEnabled = _d.isEnabled, isInteractive = _d.isInteractive, fieldRequired = _d.isRequired;
    var validation = useMemo(function () {
        return buildFieldValidation(element, {
            isRequired: fieldRequired,
            readOnly: !isEnabled,
        });
    }, [element, fieldRequired, isEnabled]);
    var fieldMaxLength = (_b = element.maxLength) !== null && _b !== void 0 ? _b : globalConstraints.maxTextLength;
    var textUpdateMode = resolveTextUpdateMode(element, {
        textUpdateMode: globalTextUpdateMode,
    });
    useClearInvisibleValue({
        isVisible: isVisible,
        valueKeys: [valueKey],
        unregister: unregister,
    });
    var initialValue = getInitialValueForElement(element);
    return (_jsx(_Fragment, { children: isVisible ? (_jsx(Box, __assign({ className: "component-wrapper" }, { children: _jsxs(FormControl, __assign({ fullWidth: true, error: !!error, sx: { mb: 3 } }, { children: [_jsx(Header, { element: element, error: !!error, isRequired: fieldRequired }), _jsx(Controller, { name: valueKey, defaultValue: initialValue, rules: {
                            validate: function (value) {
                                var _a;
                                var result = validation.safeParse(value);
                                if (!result.success) {
                                    return ((_a = result.error.errors[0]) === null || _a === void 0 ? void 0 : _a.message) || "Valor inválido";
                                }
                                return true;
                            },
                        }, render: function (_a) {
                            var field = _a.field;
                            return (_jsx(CommentFieldInput, { field: field, element: element, textUpdateMode: textUpdateMode, error: !!error, errorMessage: (error === null || error === void 0 ? void 0 : error.message) || "", isEnabled: isInteractive, fieldMaxLength: fieldMaxLength, autoGrowComment: globalConstraints.autoGrowComment }));
                        } })] })) }))) : null }));
};
export default CommentField;
